import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "../App";

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from hash fragment
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error("No session_id found in URL");
          navigate("/login", { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for user data
        const response = await axios.post(
          `${API}/auth/session`,
          {},
          {
            headers: { "X-Session-ID": sessionId },
            withCredentials: true
          }
        );

        const user = response.data;

        // Clear the hash from URL and navigate to dashboard with user data
        navigate("/dashboard", { 
          replace: true, 
          state: { user } 
        });

      } catch (error) {
        console.error("Auth callback error:", error);
        navigate("/login", { 
          replace: true,
          state: { error: "Authentication failed. Please try again." }
        });
      }
    };

    processAuth();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#020408] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-pulse-glow w-16 h-16 rounded-full border-2 border-primary-main mx-auto mb-6 flex items-center justify-center">
          <div className="w-8 h-8 rounded-full bg-primary-main/30" />
        </div>
        <p className="text-gray-400 font-mono text-sm uppercase tracking-wider">
          Authenticating...
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
